import {EntityType} from "../core/entityType";
import {Operation} from "../core/operation";

export const entityType = EntityType.Namespace;
export const entityOperations = [
  Operation.getAll,
  Operation.create,
  Operation.delete,
  Operation.update,
];
